// extracted by mini-css-extract-plugin
module.exports = {"taboola":"taboola___3CUsq"};